module.exports = "/_next/static/images/105037dd963cd6658c6cfa6cb9f284e6-folha-de-sp-logo.png.webp";